import * as React from 'react';
import { Box, Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import QuarantineDialogMessage from './QuarantineDialogMessage';
import { LoadingButton } from '@mui/lab';
import { ApiStatus } from '../../api/apiStatus';

interface IProps {
  heading: string;
  detailReason: string;
  openDialog: boolean;
  showConfirmButton: boolean;
  status: ApiStatus;
  closeDialog: () => void;
  confirm: () => void;
}

export default function QuarantineDialogBox({ heading, detailReason, openDialog, showConfirmButton, status, closeDialog, confirm }: IProps) {
  return (<>
    <Dialog open={openDialog} fullWidth={true} maxWidth='md'>
      <QuarantineDialogMessage detailReason={detailReason} title={heading} closeDialog={closeDialog}></QuarantineDialogMessage>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-around',
        }}
      >
        <Button
          variant="contained"
          data-id="button"
          size="large"
          sx={{ mb: 3, width: { xs: '80%', sm: '45%' } }}
          onClick={closeDialog}
        >
          Cancel
        </Button>
        {showConfirmButton && <LoadingButton
          variant="contained"
          size="large"
          type="submit"
          loading={status === 'LOADING'}
          sx={{ mb: 3, width: { xs: '80%', sm: '45%' } }}
          onClick={confirm}
        >
          Continue
        </LoadingButton>}
      </Box>
    </Dialog>
  </>
  );
}

